<template>
  <div class="relative">
    <button
      type="button"
      id="toggle-dropdown"
      @click="toggleDropdown"
      class="btn btn-sm"
    >
      Akcije
    </button>

    <div v-if="dropdownOpen" class="absolute top-10 right-2 m-auto z-100">
      <div class="flex items-center justify-center flex-col bg-gray-100 p-2 rounded shadow-md">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dropdownOpen: false,
    };
  },

  created() {
    document.body.addEventListener(
      "click",
      (event) => {
        if (event.target.id === "toggle-dropdown") {
          return;
        }

        this.dropdownOpen = false;
      },
      true
    );
  },

  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
  },
};
</script>
